<template>
  <div id="hud">
    <div class="hud-section">
      <div class="stat">
        <span class="label">HP:</span>
        <span class="value" :class="{ low: health < 30 }">{{ health }}</span>
        <div class="health-bar">
          <div class="health-fill" :style="{ width: health + '%' }"></div>
        </div>
      </div>
      
      <div class="stat">
        <span class="label">Ammo:</span>
        <span class="value" :class="{ low: ammo < 10 }">{{ ammo }}</span>
        <span v-if="isReloading" class="reloading-indicator">RELOADING...</span>
      </div>
      
      <div class="stat">
        <span class="label">Kills:</span>
        <span class="value kills">{{ kills }}</span>
      </div>
      
      <div class="stat">
        <span class="label">Wave:</span>
        <span class="value wave">{{ wave }}</span>
      </div>
    </div>
    
    <div class="hud-section right">
      <div class="stat">
        <span class="label">FPS:</span>
        <span class="value">{{ fps }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  health: { type: Number, default: 100 },
  ammo: { type: Number, default: 30 },
  kills: { type: Number, default: 0 },
  isReloading: { type: Boolean, default: false },
  wave: { type: Number, default: 1 }
});

const fps = ref(60);
let fpsInterval = null;

onMounted(() => {
  let lastTime = performance.now();
  let frameCount = 0;
  
  fpsInterval = setInterval(() => {
    frameCount++;
    const currentTime = performance.now();
    if (currentTime >= lastTime + 1000) {
      fps.value = frameCount;
      frameCount = 0;
      lastTime = currentTime;
    }
  }, 100);
});

onUnmounted(() => {
  if (fpsInterval) {
    clearInterval(fpsInterval);
  }
});
</script>

<style scoped>
#hud {
  position: absolute;
  bottom: 20px;
  left: 20px;
  color: #fff;
  font-size: 1.2em;
  pointer-events: none;
  z-index: 102;
}

/* Tablet responsive adjustments */
@media (max-width: 1024px) {
  #hud {
    font-size: 1em;
    bottom: 10px;
    left: 10px;
  }
  
  .hud-section {
    padding: 10px;
    margin-bottom: 8px;
  }
  
  .health-bar {
    width: 150px;
  }
}

.hud-section {
  background: rgba(0, 0, 0, 0.7);
  padding: 15px;
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 10px;
}

.hud-section.right {
  position: absolute;
  bottom: 20px;
  right: 20px;
  left: auto;
}

.stat {
  margin-bottom: 10px;
}

.stat:last-child {
  margin-bottom: 0;
}

.label {
  color: #aaa;
  margin-right: 10px;
}

.value {
  color: #fff;
  font-weight: bold;
  font-size: 1.1em;
}

.value.low {
  color: #ff4444;
  animation: pulse 1s infinite;
}

.value.kills {
  color: #ffaa00;
}

.value.wave {
  color: #00ff00;
  font-size: 1.2em;
}

.reloading-indicator {
  display: inline-block;
  margin-left: 10px;
  color: #ffaa00;
  font-size: 0.9em;
  font-weight: bold;
  animation: pulse 0.5s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.health-bar {
  width: 200px;
  height: 8px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  margin-top: 5px;
  overflow: hidden;
}

.health-fill {
  height: 100%;
  background: linear-gradient(90deg, #ff4444, #ffaa00, #44ff44);
  transition: width 0.3s ease;
  border-radius: 4px;
}
</style>

